export default __webpack_public_path__ + "static/media/m_section1-process-bg.79ac54a6.png";